import React from "react"
import { IngestionJob } from "../../api/ingestionJob"
import { AddPaymentsStep } from "./add-payments-step"
import { ConfirmPaymentsDataStep } from "./confirm-payments-data-step"
import { InblockedPaymentsDataStep } from "./inblocked-payments-data-step"

export const PaymentsWorkflow = ({ isEdit, workflowStep, job, next, back, cancel, startOver, $refreshEvents }:
    { isEdit: boolean, workflowStep: number, job: IngestionJob, next, back, cancel, startOver, $refreshEvents }) => {
    const isAddStepEnabled = () => {
        if (isEdit) return false;

        return workflowStep === 1;
    }

    const isConfirmDataStepEnabled = () => {
        if (isEdit && workflowStep == 0) return true;

        return workflowStep === 2;
    }

    const isInblockedDataStepEnabled = () => {
        if (isEdit && workflowStep == 1) return true;

        return workflowStep === 3;
    }

    return <>
        {isAddStepEnabled() && <AddPaymentsStep job={job} next={next} back={back} cancel={cancel} />}
        {isConfirmDataStepEnabled() && <ConfirmPaymentsDataStep isEdit={isEdit} job={job} next={next} cancel={cancel} startOver={startOver} $refreshEvents={$refreshEvents} />}
        {isInblockedDataStepEnabled() && <InblockedPaymentsDataStep job={job} back={back} $refreshEvents={$refreshEvents} />}
    </>
}
